import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LeadDataRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("LeadData");
